import { release } from '@awayfl/swf-loader';
import { checkValue } from './checkValue';
export function axIsTypeInterface(x) {
    if (!x || typeof x !== 'object') {
        return false;
    }
    release || checkValue(x);
    return x.axImplementsInterface(this);
}
